import Image from 'next/image'
import Link from 'next/link'
import { cn } from '@/utils/styles/cn'
import { UrlConfig } from '@/setup/routing/routing'
import { LP_GRID } from '@/features/landing-page/v3/lp-grid'
import { SolutionsMenu } from '@/features/landing-page/v3/solutions-menu'
import { NavPrimaryLinks } from '@/features/landing-page/v3/nav-primary-links'
import { NavCtaButtons } from '@/features/landing-page/v3/nav-cta-buttons'
import { NavMobileMenu } from '@/features/landing-page/v3/nav-mobile-menu'
import { LP_V3_NAV_HEIGHT } from '@/features/landing-page/v3/landing-v3-nav-constants'

/**
 * lp-v3 logged-out marketing nav — a SERVER component so the bar and every link ship in the static
 * HTML. The desktop Solutions mega-menu (SolutionsMenu) is a thin client island — still hover/focus
 * revealed, but it also closes when an option is clicked; the mobile experience is one client island
 * (NavMobileMenu) that expands the bar in place.
 */
export function LandingV3NavBar() {
    return (
        <>
            {/* Desktop bar */}
            <header
                // Transparent chrome: a soft cream fade instead of a solid blur bar, so full-bleed
                // sections stay immersive. `.lp-nav-inverted` (set by the statement section) flips
                // the content to cream — see globals.css.
                className="lp-v3-nav-chrome fixed inset-x-0 top-0 z-40 hidden bg-gradient-to-b from-background via-background/60 to-transparent md:block"
                style={{ height: LP_V3_NAV_HEIGHT }}
            >
                {/* Full-width bar background; the content aligns to the shared lp-v3 grid column. */}
                <div className={cn(LP_GRID.contentSection, 'h-full')}>
                    <div className={cn(LP_GRID.content, 'flex h-full items-center gap-4')}>
                    <Link href={UrlConfig['/'].getUrl()} aria-label="Superscale home" className="shrink-0">
                        <Image
                            src="/assets/landing-v3/superscale-logo-with-text.svg"
                            alt="Superscale"
                            width={149}
                            height={32}
                            className="lp-nav-logo h-7 w-auto"
                            priority
                        />
                    </Link>

                    <nav className="flex flex-1 items-center justify-center gap-1">
                        {/* Client island: hover/focus-reveal mega-menu (links ship in the HTML) that also
                            closes when an option is clicked. */}
                        <SolutionsMenu />

                        {/* Client island: same markup as before, plus an active pill on the current page. */}
                        <NavPrimaryLinks />
                    </nav>

                    <div className="shrink-0">
                        <NavCtaButtons layout="row" />
                    </div>
                    </div>
                </div>
            </header>

            {/* Mobile nav — expands the bar in place */}
            <NavMobileMenu />
        </>
    )
}
